module.exports = __webpack_public_path__ + "static/media/97gal21.f817eaaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/97gal/97gal21.jpg
// module id = 236
// module chunks = 0